import { TableColumnMeta } from "ds/components/Table/types";

export const TEMPLATE_VERSIONS_COLUMNS_STORAGE_KEY = "templateVersionsColumnsConfig";

export enum TEMPLATE_VERSIONS_COLUMN_ID {
  STATE = "STATE",
  DESCRIPTION = "DESCRIPTION",
  LATEST_VERSION = "LATEST_VERSION",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const TEMPLATE_VERSIONS_COLUMN_CONFIG: Record<TEMPLATE_VERSIONS_COLUMN_ID, TableColumnMeta> =
  {
    [TEMPLATE_VERSIONS_COLUMN_ID.STATE]: {
      id: TEMPLATE_VERSIONS_COLUMN_ID.STATE,
      title: "Status",
      minWidth: 180,
      defaultWidth: 180,
      maxWidth: MAX_CELL_WIDTH,
      allowsSorting: true,
      resizable: true,
      canHide: true,
      canPin: true,
      canMove: true,
    },
    [TEMPLATE_VERSIONS_COLUMN_ID.LATEST_VERSION]: {
      id: TEMPLATE_VERSIONS_COLUMN_ID.LATEST_VERSION,
      title: "Version identifier",
      minWidth: 160,
      defaultWidth: 160,
      maxWidth: MAX_CELL_WIDTH,
      allowsSorting: true,
      resizable: true,
      canHide: true,
      canPin: true,
      canMove: true,
    },
    [TEMPLATE_VERSIONS_COLUMN_ID.DESCRIPTION]: {
      id: TEMPLATE_VERSIONS_COLUMN_ID.DESCRIPTION,
      title: "Deployment instruction",
      minWidth: 150,
      defaultWidth: 200,
      maxWidth: MAX_CELL_WIDTH,
      resizable: true,
      canHide: true,
      canPin: true,
      canMove: true,
    },
    [TEMPLATE_VERSIONS_COLUMN_ID.DROPDOWN]: {
      id: TEMPLATE_VERSIONS_COLUMN_ID.DROPDOWN,
      title: "Version actions",
      noHeader: true,
      minWidth: 60,
      defaultWidth: 60,
      maxWidth: 60,
      allowsSorting: false,
      resizable: false,
      canHide: false,
      configurable: false,
      canPin: false,
      canMove: false,
    },
  };

export const TEMPLATE_VERSIONS_SORT_CONFIG: Record<string, string> = {
  [TEMPLATE_VERSIONS_COLUMN_ID.STATE]: "state",
  [TEMPLATE_VERSIONS_COLUMN_ID.LATEST_VERSION]: "version",
};
